import { LoadableLazy } from '@confluence/loadable';

export type { PageQuickActionAutomationMenuProps } from '../src/PageQuickActionAutomationMenu.tsx';
export const PageQuickActionAutomationMenu = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PageQuickActionAutomationMenu" */ '../src/PageQuickActionAutomationMenu.tsx'
			)
		).PageQuickActionAutomationMenu,
});
